import React, { useEffect, useState, useMemo } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { AiOutlineClose, AiOutlineEdit, AiOutlineEye } from "react-icons/ai";
import SummaryApi from "../common"; // Import your API configuration
import { useTable, usePagination } from "react-table";
import * as XLSX from "xlsx";
import { IoIosCloseCircle } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaFileExcel } from "react-icons/fa";

const EnrolledStudents = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [studentsData, setStudentsData] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [enrollmentCode, setEnrollmentCode] = useState(null);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]); // Stores selected courses
  const [dropdownValue, setDropdownValue] = useState(""); // Value of selected option
  const [minEnrolledDate, setMinEnrolledDate] = useState(null);
  const [maxEnrolledDate, setMaxEnrolledDate] = useState(new Date());
  const [dataLimit, setDataLimit] = useState(0);
  const [totalStudents, setTotalStudents] = useState();
  const reasons = [
    "Wrong Number",
    "Not Reachable",
    "Number Not Working",
    "Call Declined",
    "Busy",
  ];
  const [selectedRange, setSelectedRange] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filterDate, setFilterDate] = useState(null);
  const [isCustomRange, setIsCustomRange] = useState(false);

  const [formData, setFormData] = useState({
    student_name: "",
    gender: "Male",
    father_name: "",
    mobile_number1: "",
    last_name: "",
    mobile_number2: "",
    email: "",
    aadhar_number: "",
    state: "",
    district: "",
    city: "",
    address: "",
    pincode: "",
    course: "",
    clg_name: "",
    program_type: "",
    department: "",
    ug_pg_course: "",
    call_back_reason: "",
    call_duration: "00:00:00.000000",
    other_reasons: "",
    is_interested: "",
    call_status: "",
    remarks: "",
    prev_call_back_reason: "",
    follow_up_date: "",
    previous_status: "",
    is_joined: "",
    joined_clg: "",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const [memberType, setMemberType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [localPageIndex, setLocalPageIndex] = useState(0);
  const [updatedData, setUpdatedData] = useState({});
  const [updatedStudent, setUpdatedStudent] = useState(0);
  const [timer, setTimer] = useState("00:00:00");
  const [intervalId, setIntervalId] = useState(null);

  const [searchModalIsOpen, setSearchModalIsOpen] = useState(false);
  const [searchDistrict, setSearchDistrict] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchCollege, setSearchCollege] = useState("");

  const headers = {
    Authorization: "Bearer indrashil_university_916",
    "Content-Type": "application/json",
  };

  // Single source of truth for program and course data
  const coursesData = {
    UG: [
       "B.Pharma",
      "B.pharma in MLT",
      "B.Sc(Hons.) in BioScience",
      "B.Sc(Hons.) in Chemistry",,
    ],
  };

  // Derived state for populating dropdowns
  const departments = useMemo(() => {
    if (!formData.program_type) return [];
    const programData = coursesData[formData.program_type];
    if (typeof programData === "object" && !Array.isArray(programData)) {
      return Object.keys(programData);
    }
    return [];
  }, [formData.program_type]);

  const courses = useMemo(() => {
    if (!formData.program_type) return [];
    const programData = coursesData[formData.program_type];
    if (Array.isArray(programData)) {
      return programData;
    }
    if (departments.length > 0 && formData.department) {
      return programData[formData.department] || [];
    }
    return [];
  }, [formData.program_type, formData.department, departments]);

  useEffect(() => {
    if (modalIsOpen) {
      let seconds = 0;
      const id = setInterval(() => {
        seconds++;
        const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(
          2,
          "0"
        );
        const secs = String(seconds % 60).padStart(2, "0");
        setTimer(`${hours}:${minutes}:${secs}`);
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
      setTimer("00:00:00");
    }
    return () => clearInterval(intervalId);
  }, [modalIsOpen]);

  const fetchStudents = async (limit) => {
    setLoading(true);
    try {
      const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
      const memberType = encodedMemberType ? atob(encodedMemberType) : null;
      setMemberType(memberType);

      let response;

      if (memberType === "Admin" || memberType === "Manager") {
        response = await fetch(
          `${SummaryApi.getAllStudents.url}?limit=${limit}`,
          {
            method: SummaryApi.getAllStudents.method,
            headers,
          }
        );
      } else {
        const encodedEmployeeId = sessionStorage.getItem(
          "H7Z4L9VD2XK5JW8QRYT6"
        );
        if (!encodedEmployeeId)
          throw new Error("Employee ID not found in session storage");
        const decodedEmployeeId = atob(encodedEmployeeId);
        response = await fetch(SummaryApi.getStudentsByEmployeeID.url, {
          method: SummaryApi.getStudentsByEmployeeID.method,
          headers,
          body: JSON.stringify({
            employee_id: decodedEmployeeId,
            limit_value: limit,
          }),
        });
      }

      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      const students = data?.data || [];
      const updatedStudentsData = students.map((student, index) => ({
        ...student,
        sno: index + 1,
        call_duration: student.call_duration
          ? student.call_duration.replace(/\.\d{6}$/, "")
          : student.call_duration,
      }));

      let divisions = 0;
      let totalStudentsCount = data?.total_students || 0;
      while (totalStudentsCount > 1000) {
        totalStudentsCount /= 2;
        divisions++;
      }
      if (dataLimit === 0) {
        setDataLimit(
          Math.round(data?.total_students / 2 ** divisions / 1000) * 1000
        );
      }
      setTotalStudents(data?.total_students);
      setStudentsData(updatedStudentsData);
      setFilteredStudents(updatedStudentsData);
    } catch (error) {
      toast.error(`Error fetching students: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents(dataLimit);
    clearFilters();
  }, [dataLimit]);

  const validateForm = () => {
    const { call_status, is_interested, call_back_reason, other_reasons } =
      formData;

    if (!(isUpdate || isUpload)) return true;

    if (!call_status) {
      toast.warning("Please select a Call Status.");
      return false;
    }

    if (call_status === "Contacted") {
      if (is_interested === "Call Back" && !call_back_reason) {
        toast.warning("Please select a Call Back reason.");
        return false;
      }
      if (is_interested === "Others" && !other_reasons) {
        toast.warning("Please select a reason for 'Others'.");
        return false;
      }
    }
    return true;
  };

  const handleFilterChange = (filter) => {
    setLocalPageIndex(0);
    setSelectedFilter(filter);
    filterStudents(filter, searchQuery, selectedRange, filterDate);
  };

  const filterStudents = (filter, search, range, filterByDate) => {
    setLocalPageIndex(0);
    let filtered = studentsData;
    const timeZone = "Asia/Kolkata";

    const formatToKolkata = (date) =>
      new Intl.DateTimeFormat("en-IN", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);

    if (filter !== "All") {
      filtered = filtered.filter((student) => student.call_status === filter);
    }

    const convertToKolkataDateString = (date) =>
      formatToKolkata(new Date(date));

    if (range === "today") {
      const todayFormatted = formatToKolkata(new Date());
      filtered = filtered.filter(
        (student) =>
          convertToKolkataDateString(new Date(student.created_date)) ===
          todayFormatted
      );
    } else if (range === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayFormatted = formatToKolkata(yesterday);
      filtered = filtered.filter(
        (student) =>
          convertToKolkataDateString(new Date(student.created_date)) ===
          yesterdayFormatted
      );
    } else if (range === "thisWeek") {
      const today = new Date();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());
      startOfWeek.setHours(0, 0, 0, 0);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= startOfWeek && studentDate <= endOfWeek;
      });
    } else if (range === "lastWeek") {
      const today = new Date();
      const startOfCurrentWeek = new Date(today);
      startOfCurrentWeek.setDate(today.getDate() - today.getDay());
      startOfCurrentWeek.setHours(0, 0, 0, 0);
      const endOfLastWeek = new Date(startOfCurrentWeek);
      endOfLastWeek.setDate(startOfCurrentWeek.getDate() - 1);
      endOfLastWeek.setHours(23, 59, 59, 999);
      const startOfLastWeek = new Date(endOfLastWeek);
      startOfLastWeek.setDate(endOfLastWeek.getDate() - 6);
      startOfLastWeek.setHours(0, 0, 0, 0);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= startOfLastWeek && studentDate <= endOfLastWeek;
      });
    } else if (range === "custom" && fromDate && toDate) {
      const fromFormatted = new Date(fromDate);
      fromFormatted.setHours(0, 0, 0, 0);
      const toFormatted = new Date(toDate);
      toFormatted.setHours(23, 59, 59, 999);
      filtered = filtered.filter((student) => {
        const studentDate = new Date(student.created_date);
        return studentDate >= fromFormatted && studentDate <= toFormatted;
      });
    }

    if (filterByDate) {
      setFilterDate(filterByDate);
      const filterD = new Date(filterByDate);
      filtered = filtered.filter(
        (student) =>
          new Date(student.created_date).toDateString() ===
          filterD.toDateString()
      );
    }

    if (search) {
      const lowercasedSearch = search.toLowerCase();
      filtered = filtered.filter(
        (student) =>
          student.student_name.toLowerCase().includes(lowercasedSearch) ||
          student.mobile_number1.toLowerCase().includes(lowercasedSearch) ||
          student.clg_name.toLowerCase().includes(lowercasedSearch) ||
          (["Admin", "Manager"].includes(memberType) &&
            student.employee_name.toLowerCase().includes(lowercasedSearch))
      );
    }
    setFilteredStudents(filtered);
  };

  const handleRangeChange = (e) => {
    const range = e.target.value;
    setSelectedRange(range);
    setIsCustomRange(range === "custom");
    if (range !== "custom") {
      setFromDate(null);
      setToDate(null);
      filterStudents(selectedFilter, searchQuery, range, filterDate);
    } else {
      setFilteredStudents([]);
    }
  };

  useEffect(() => {
    if (fromDate && toDate) {
      filterStudents(selectedFilter, searchQuery, "custom", filterDate);
    }
  }, [fromDate, toDate]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    filterStudents(selectedFilter, e.target.value, selectedRange, filterDate);
  };

  const findDepartmentForCourse = (programType, courseName) => {
    if (!programType || !courseName || !coursesData[programType]) return "";
    const programData = coursesData[programType];
    if (Array.isArray(programData)) return "";

    const trimmedCourseName = courseName.trim();
    for (const dept in programData) {
      if (programData[dept].includes(trimmedCourseName)) {
        return dept;
      }
    }
    return "";
  };

  const openModal = (student = null, mode = "view") => {
    const sanitizeStudentData = (data) => {
      const sanitizedData = { ...data };
      Object.keys(sanitizedData).forEach((key) => {
        if (sanitizedData[key] === "N/A") sanitizedData[key] = "";
      });
      return sanitizedData;
    };

    let foundDepartment = student?.department || "";
    const coursesArray = student?.ug_pg_course
      ? student.ug_pg_course.split(",").map((c) => c.trim())
      : [];

    if (!foundDepartment && student?.program_type && coursesArray.length > 0) {
      foundDepartment = findDepartmentForCourse(
        student.program_type,
        coursesArray[0]
      );
    }

    const payload = {
      ...formData,
      ...student,
      department: foundDepartment,
      mobile_number2: student?.mobile_number2 || "",
      email: student?.email || "",
      aadhar_number: student?.aadhar_number || "",
      pincode: student?.pincode || "",
      call_status: student?.call_status || "",
      call_duration: student?.call_duration || "00:00:00",
      remarks: student?.remarks || "",
      is_joined: student?.is_joined || "",
      joined_clg: student?.joined_clg || "",
      is_interested: reasons.includes(student?.is_interested)
        ? "Others"
        : student?.is_interested,
      other_reasons: student?.is_interested,
    };

    const sanitizedStudent = sanitizeStudentData(payload);

    // --- ROBUST PARSING LOGIC ---
    let hours = "00",
      minutes = "00",
      seconds = "00";
    const duration = sanitizedStudent.call_duration;

    if (duration && typeof duration === "string") {
      const [timePart] = duration.split(".");
      if (timePart) {
        const parts = timePart.split(":");
        if (parts.length === 3) {
          [hours, minutes, seconds] = parts;
        }
      }
    }
    // --- END ROBUST PARSING LOGIC ---

    setFormData({
      ...sanitizedStudent,
      hours: hours.padStart(2, "0"),
      minutes: minutes.padStart(2, "0"),
      seconds: seconds.padStart(2, "0"),
    });

    if (mode === "edit" || mode === "view") {
      setIsUpdate(mode === "edit");
      setIsUpload(false);
      setSelectedCourses(coursesArray);
    } else if (mode === "add") {
      setFormData({
        student_name: "",
        gender: "Male",
        father_name: "",
        mobile_number1: "",
        mobile_number2: "",
        last_name: "",
        email: "",
        aadhar_number: "",
        state: "",
        district: "",
        city: "",
        address: "",
        pincode: "",
        course: "",
        clg_name: "",
        remarks: "",
        call_status: "",
        call_duration: "00:00:00",
        program_type: "",
        department: "",
        ug_pg_course: "",
        is_interested: "",
        is_joined: "",
        joined_clg: "",
        hours: "00",
        minutes: "00",
        seconds: "00",
      });
      setIsUpdate(false);
      setIsUpload(true);
      setSelectedCourses([]);
    }
    setSelectedStudent(student);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedStudent(null);
    setIsUpdate(false);
    setIsUpload(false);
  };

  // FIX: This function is corrected to handle the "Not Answered" status properly.
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "call_status") {
      if (value === "Not Answered") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "", // Changed from "Others" to ""
          call_back_reason: "",
          other_reasons: "",
          is_joined: "",
          joined_clg: "",
          program_type: "",
          department: "",
          ug_pg_course: "",
        }));
        setSelectedCourses([]);
      } else if (value === "Contacted") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "",
          call_back_reason: "",
          other_reasons: "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "",
          call_back_reason: "",
          other_reasons: "",
          is_joined: "",
          joined_clg: "",
          program_type: "",
          department: "",
          ug_pg_course: "",
        }));
        setSelectedCourses([]);
      }
    } else if (name === "is_interested") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(value !== "Call Back" && { call_back_reason: "" }),
        ...(value !== "Others" && { other_reasons: "" }),
      }));
    } else if (name === "program_type") {
      setSelectedCourses([]);
      setDropdownValue("");
      setFormData((prev) => ({
        ...prev,
        program_type: value,
        department: "",
        ug_pg_course: "",
      }));
    } else if (name === "department") {
      setSelectedCourses([]);
      setDropdownValue("");
      setFormData((prev) => ({ ...prev, department: value, ug_pg_course: "" }));
    } else if (name === "is_joined") {
      setFormData((prev) => ({
        ...prev,
        is_joined: value,
        ...(value !== "Already Joined" && { joined_clg: "" }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = (e) => {
    const selectedCourse = e.target.value;
    if (selectedCourse && !selectedCourses.includes(selectedCourse)) {
      setSelectedCourses((prev) => [...prev, selectedCourse]);
    }
    setDropdownValue("");
  };

  const handleRemoveTag = (course) => {
    setSelectedCourses((prev) => prev.filter((c) => c !== course));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    setLoadingSubmit(true);

    try {
      const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
      if (!encodedEmployeeId) throw new Error("Employee ID not found");
      const decodedEmployeeId = atob(encodedEmployeeId);
      const apiEndpoint = isUpdate
        ? SummaryApi.updateStudent.url
        : SummaryApi.uploadStudent.url;
      const method = isUpdate
        ? SummaryApi.updateStudent.method
        : SummaryApi.uploadStudent.method;

      const payloadData = {
        student_name: formData.student_name,
        last_name: "",
        gender: formData.gender,
        father_name: formData.father_name,
        mobile_number1: formData.mobile_number1,
        mobile_number2: formData.mobile_number2,
        email: formData.email,
        aadhar_number: formData.aadhar_number,
        state: formData.state,
        district: formData.district,
        city: formData.city,
        address: formData.address,
        pincode: formData.pincode,
        course: formData.course,
        clg_name: formData.clg_name,
        inter_percentage: formData.inter_percentage,
        program_type: formData.program_type,
        department: formData.department,
        ug_pg_course: selectedCourses.join(", "),
        is_joined: formData.is_joined,
        joined_clg: formData.joined_clg,
        call_status: formData.call_status,
        call_duration: timer,
        remarks: formData.remarks,
        is_interested:
          formData.is_interested === "Others"
            ? formData.other_reasons
            : formData.is_interested,
        is_jee:
          formData.is_jee === "Jee Mains Results"
            ? "Jee Mains Results"
            : ["Interested", "Not Interested", "Most Interested"].includes(
                formData.is_interested
              )
            ? formData.prev_call_back_reason === "Jee Mains Results"
              ? "Jee Mains Results"
              : ""
            : "",
        is_jee2:
          formData.is_jee2 === "Jee Mains-2 Results"
            ? "Jee Mains-2 Results"
            : ["Interested", "Not Interested", "Most Interested"].includes(
                formData.is_interested
              )
            ? formData.prev_call_back_reason === "Jee Mains-2 Results"
              ? "Jee Mains-2 Results"
              : ""
            : "",
        call_back_reason: formData.call_back_reason,
        follow_up_date: new Date().toISOString(),
      };

      const payload = isUpdate
        ? {
            ...payloadData,
            student_id: selectedStudent.student_id,
            employee_id: decodedEmployeeId,
          }
        : { ...payloadData, employee_id: decodedEmployeeId };

      const response = await fetch(apiEndpoint, {
        method,
        headers,
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();

      if (result.status) {
        toast.success(
          isUpdate
            ? "Student updated successfully!"
            : "Student added successfully!"
        );
        if (!isUpdate) setEnrollmentCode(result.ENR_CODE);
        setUpdatedData(payloadData);
        setUpdatedStudent(selectedStudent?.student_id);
        const updateList = (list) =>
          list.map((s) =>
            s.student_id === payload.student_id ? { ...s, ...payloadData } : s
          );
        setStudentsData(updateList);
        setFilteredStudents(updateList);
        closeModal();
        setSelectedCourses([]);
        setDropdownValue("");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const downloadExcelReport = () => {
    const requiredFields = [
      "enrollment_code",
      "student_name",
      "email",
      "mobile_number1",
      "mobile_number2",
      "aadhar_number",
      "state",
      "district",
      "city",
      "address",
      "pincode",
      "course",
      "clg_name",
      "created_date",
      "call_duration",
      "call_status",
      "remarks",
      "employee_name",
    ];

    const filteredData = filteredStudents.map((student) => {
      const selectedData = {};
      requiredFields.forEach((field) => {
        selectedData[field] = student[field];
      });
      return selectedData;
    });

    const headers = {
      enrollment_code: "Enrollment Code",
      student_name: "Student Name",
      email: "Email",
      mobile_number1: "Mobile Number 1",
      mobile_number2: "Mobile Number 2",
      aadhar_number: "Aadhar Number",
      state: "State",
      district: "District",
      city: "City",
      address: "Address",
      pincode: "Pincode",
      course: "Course",
      clg_name: "College",
      created_date: "Enrolled Date",
      call_status: "Call Status",
      call_duration: "Call Duration",
      remarks: "Remarks",
      employee_name: "Employee Name",
    };

    const formattedData = filteredData.map((student) => {
      return Object.fromEntries(
        Object.entries(student).map(([key, value]) => [headers[key], value])
      );
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    XLSX.writeFile(workbook, "students_report.xlsx");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "NA";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const columns = React.useMemo(
    () => [
      { Header: "SNO", Cell: ({ row }) => row.index + 1 },
      ...(["Admin", "Manager"].includes(memberType)
        ? [{ Header: "Employee Name", accessor: "employee_name" }]
        : []),
      { Header: "Enrollment Code", accessor: "enrollment_code" },
      { Header: "Student Name", accessor: "student_name" },
      { Header: "District", accessor: "district" },
      { Header: "City", accessor: "city" },
      { Header: "College Name", accessor: "clg_name" },
      { Header: "Address", accessor: "address" },
      { Header: "Mobile Number", accessor: "mobile_number1" },
      { Header: "Call Duration", accessor: "call_duration" },
      { Header: "Course", accessor: "course" },
      {
        Header: "Enrolled Date",
        accessor: "created_date",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Follow Up Date",
        accessor: "follow_up_date",
        Cell: ({ value }) => formatDate(value),
      },
      { Header: "Previous Status", accessor: "prevs_is_interested" },
      { Header: "Current Status", accessor: "is_interested" },
      ...(["Employee", "Consultant"].includes(memberType)
        ? [
            {
              Header: "Edit",
              Cell: ({ row }) => (
                <button
                  className="bg-green-600 text-white px-3 py-2 rounded-md hover:scale-105"
                  onClick={() => openModal(row.original, "edit")}
                >
                  <AiOutlineEdit className="inline-block mr-1" />
                  Edit
                </button>
              ),
            },
          ]
        : []),
      {
        Header: "View More",
        Cell: ({ row }) => (
          <button
            className="bg-yellow-600 text-white px-3 py-2 rounded-md hover:scale-105"
            onClick={() => openModal(row.original, "view")}
          >
            <AiOutlineEye className="inline-block mr-1" />
            View
          </button>
        ),
      },
    ],
    [memberType]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize },
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageCount,
  } = useTable(
    { columns, data: filteredStudents, initialState: { pageIndex: 0 } },
    usePagination
  );

  useEffect(() => {
    setLocalPageIndex(pageIndex);
  }, [pageIndex]);

  const clearFilters = () => {
    setSelectedRange("");
    setFromDate(null);
    setToDate(null);
    setIsCustomRange(false);
    setFilteredStudents(studentsData);
    setSelectedFilter("All");
    setSearchQuery("");
    setFilterDate(null);
  };

  return (
    <div className="mx-auto">
      {loading ? (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-20 flex justify-center items-center">
          <span className="text-white text-lg">Fetching Data...</span>
        </div>
      ) : (
        <>
          <div className="mx-auto">
            <div className="absolute top-[100px] right-[50px]">
              <div className="flex justify-end items-baseline">
                <span className="text-xl text-center">
                  <span className="text-red-600 font-bold">
                    {studentsData.length}
                  </span>{" "}
                  of{" "}
                  <span className="text-green-500 font-bold">
                    {totalStudents}
                  </span>{" "}
                  Records Loaded
                </span>
                <div>
                  <select
                    value={dataLimit}
                    onChange={(e) => setDataLimit(Number(e.target.value))}
                    className="border rounded px-3 py-2 w-full ml-4"
                  >
                    <option value={0} disabled>
                      Select limit
                    </option>
                    {(() => {
                      const uniqueValues = new Set();
                      const divisions = [];
                      let totalStudentsValue = totalStudents;
                      while (totalStudentsValue > 1000) {
                        totalStudentsValue /= 2;
                        divisions.push(
                          Math.round(totalStudentsValue / 1000) * 1000
                        );
                      }
                      if (
                        totalStudents > 0 &&
                        !divisions.includes(totalStudents)
                      ) {
                        divisions.push(totalStudents);
                      }
                      divisions.sort((a, b) => a - b);
                      return divisions.map((value) => {
                        if (!uniqueValues.has(value)) {
                          uniqueValues.add(value);
                          return (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          );
                        }
                        return null;
                      });
                    })()}
                  </select>
                </div>
              </div>
            </div>
            {loadingSubmit && (
              <div className="fixed inset-0 bg-black bg-opacity-70 z-20 flex justify-center items-center">
                <span className="text-white text-lg">Submitting...</span>
              </div>
            )}
            <div className="flex justify-between mb-6">
              <h1 className="text-3xl font-bold">Enrolled Students</h1>
            </div>
            <div>
              <div className="flex justify-between">
                <div>
                  <button
                    className={`py-2 px-4 rounded-lg text-white ${
                      selectedFilter === "All" ? "bg-gray-500" : "bg-blue-500"
                    }`}
                    onClick={() => handleFilterChange("All")}
                  >
                    All
                  </button>
                  <button
                    className={`py-2 px-4 rounded-lg text-white ml-6 ${
                      selectedFilter === "Contacted"
                        ? "bg-gray-500"
                        : "bg-blue-500"
                    }`}
                    onClick={() => handleFilterChange("Contacted")}
                  >
                    Contacted
                  </button>
                  <button
                    className={`py-2 px-4 rounded-lg text-white ml-6 ${
                      selectedFilter === "Not Answered"
                        ? "bg-gray-500"
                        : "bg-blue-500"
                    }`}
                    onClick={() => handleFilterChange("Not Answered")}
                  >
                    Not Answered
                  </button>
                  <button
                    onClick={() => setSearchModalIsOpen(true)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg ml-5"
                  >
                    Advanced Search
                  </button>
                </div>
                <div>
                  {["Admin", "Manager"].includes(memberType) && (
                    <div>
                      <label htmlFor="dateRange">Select Date Range:</label>
                      <select
                        id="dateRange"
                        className="bg-blue-500 py-2 px-4 text-white rounded-lg ml-4"
                        onChange={handleRangeChange}
                        value={selectedRange}
                      >
                        <option value="">Select a range</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="thisWeek">This Week</option>
                        <option value="lastWeek">Last Week</option>
                        <option value="custom">Custom</option>
                      </select>
                      <button
                        onClick={clearFilters}
                        className="px-4 py-2 ml-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none"
                      >
                        Clear Filters
                      </button>

                      {isCustomRange && (
                        <div className="flex mt-4 gap-4">
                          <div>
                            <label>From:</label>
                            <DatePicker
                              selected={fromDate}
                              onChange={(date) => setFromDate(date)}
                              selectsStart
                              startDate={fromDate}
                              endDate={toDate}
                              minDate={minEnrolledDate}
                              maxDate={toDate || maxEnrolledDate}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Select From Date"
                              className="p-2 ml-2 border rounded-lg"
                            />
                          </div>
                          <div>
                            <label>To:</label>
                            <DatePicker
                              selected={toDate}
                              onChange={(date) => setToDate(date)}
                              selectsEnd
                              startDate={fromDate}
                              endDate={toDate}
                              minDate={fromDate || minEnrolledDate}
                              maxDate={maxEnrolledDate}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Select To Date"
                              className="p-2 ml-2 border rounded-lg"
                              disabled={!fromDate}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {["Employee"].includes(memberType) && (
                    <div className="flex">
                      <div>
                        <DatePicker
                          selected={filterDate}
                          onChange={(date) =>
                            filterStudents(
                              selectedFilter,
                              searchQuery,
                              selectedRange,
                              date
                            )
                          }
                          endDate={toDate}
                          maxDate={toDate || maxEnrolledDate}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Select Date"
                          className="p-2 ml-2 border rounded-lg"
                        />
                      </div>
                      <button
                        onClick={clearFilters}
                        className="px-4 py-2 ml-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none"
                      >
                        Clear Filters
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-between mt-4">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder={
                    ["Admin", "Manager"].includes(memberType)
                      ? "Search by student, college, mobile, or employee"
                      : "Search by student, college, or mobile"
                  }
                  className="py-2 px-4 border rounded-lg w-1/3"
                />
                {["Admin"].includes(memberType) && (
                  <button
                    className="bg-green-500 text-white px-4 py-2 rounded-lg"
                    onClick={downloadExcelReport}
                    disabled={loading}
                  >
                    <FaFileExcel className="inline-block mr-2" />
                    Download Report
                  </button>
                )}
              </div>
            </div>
            <div className="overflow-x-auto p-4">
              <table
                {...getTableProps()}
                className="min-w-full mb-4 rounded-lg shadow-md"
              >
                <thead className="bg-gray-200">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps()}
                          className="px-4 py-2 text-left font-semibold"
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} className="hover:bg-gray-100">
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            className="border px-4 py-2"
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="flex justify-between items-center">
                <span>
                  Page {pageIndex + 1} of {pageCount}
                </span>
                <div>
                  <button
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                    className="px-3 py-1 border rounded"
                  >
                    {"<<"}
                  </button>
                  <button
                    onClick={previousPage}
                    disabled={!canPreviousPage}
                    className="px-3 py-1 border rounded"
                  >
                    {"<"}
                  </button>
                  <button
                    onClick={nextPage}
                    disabled={!canNextPage}
                    className="px-3 py-1 border rounded"
                  >
                    {">"}
                  </button>
                  <button
                    onClick={() => gotoPage(pageCount - 1)}
                    disabled={!canNextPage}
                    className="px-3 py-1 border rounded"
                  >
                    {">>"}
                  </button>
                </div>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[5, 10, 20, 50, 100].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Student Details"
            className="mx-auto my-10 mt-[100px] max-h-[85vh] max-w-full sm:max-w-4xl bg-white rounded-lg shadow-lg overflow-auto"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          >
            <div className="sticky top-0 z-10 bg-white px-8 py-4 border-b">
              <div className="flex justify-between items-center">
                <h2 className="text-2xl font-semibold">
                  {isUpdate
                    ? "Edit Student"
                    : isUpload
                    ? "Add Student"
                    : "Student Details"}
                </h2>
                {(isUpdate || isUpload) && (
                  <div className="text-2xl font-medium bg-blue-500 text-white px-3 py-1 rounded-lg">
                    {timer}
                  </div>
                )}
                <button onClick={closeModal}>
                  <AiOutlineClose className="w-6 h-6" />
                </button>
              </div>
            </div>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-8"
            >
              <div className="flex flex-col">
                <label htmlFor="student_name">
                  Student Name<span className="ml-1 text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="student_name"
                  name="student_name"
                  value={formData.student_name}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  required
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="gender" className="flex items-center">
                  Gender
                </label>
                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="father_name" className="flex items-center">
                  Father Name
                </label>
                <input
                  type="text"
                  id="father_name"
                  name="father_name"
                  value={formData.father_name}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="mobile_number1" className="flex items-center">
                  Mobile Number 1<span className="ml-1 text-red-600">*</span>
                </label>
                <input
                  type="tel"
                  id="mobile_number1"
                  name="mobile_number1"
                  value={formData.mobile_number1}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 10) {
                      setFormData((prev) => ({
                        ...prev,
                        mobile_number1: value,
                      }));
                    }
                  }}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  required
                  pattern="\d{10}"
                  title="Mobile number must be exactly 10 digits."
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="mobile_number2" className="flex items-center">
                  Mobile Number 2:
                </label>
                <input
                  type="tel"
                  id="mobile_number2"
                  name="mobile_number2"
                  value={formData.mobile_number2}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 10) {
                      setFormData((prev) => ({
                        ...prev,
                        mobile_number2: value,
                      }));
                    }
                  }}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  pattern="\d{10}"
                  title="Mobile number must be exactly 10 digits."
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="email" className="flex items-center">
                  Email:
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="aadhar_number" className="flex items-center">
                  Aadhar Number:
                </label>
                <input
                  type="text"
                  id="aadhar_number"
                  name="aadhar_number"
                  value={formData.aadhar_number}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/-/g, "");
                    const formattedValue = rawValue
                      .replace(/\D/g, "")
                      .replace(/(\d{4})(?=\d)/g, "$1-");

                    if (formattedValue.length <= 14) {
                      setFormData((prev) => ({
                        ...prev,
                        aadhar_number: formattedValue,
                      }));
                    }
                  }}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  pattern="(\d{4}-\d{4}-\d{4})"
                  title="Aadhar number must be in the format 1234-5678-9012."
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="state" className="flex items-center">
                  State
                </label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="district" className="flex items-center">
                  District
                </label>
                <input
                  type="text"
                  id="district"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="city" className="flex items-center">
                  City:
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="address" className="flex items-center">
                  Address:
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="pincode" className="flex items-center">
                  Pincode:
                </label>
                <input
                  type="text"
                  id="pincode"
                  name="pincode"
                  value={formData.pincode}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 6) {
                      setFormData((prev) => ({ ...prev, pincode: value }));
                    }
                  }}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  pattern="\d{6}"
                  title="Pincode must be exactly 6 digits."
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="course" className="flex items-center">
                  Course
                </label>
                <input
                  type="text"
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="clg_name" className="flex items-center">
                  College
                </label>
                <input
                  type="text"
                  id="clg_name"
                  name="clg_name"
                  value={formData.clg_name}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="inter_percentage" className="flex items-center">
                  Intermediate Percentage/CGPA
                </label>
                <input
                  type="text"
                  id="inter_percentage"
                  name="inter_percentage"
                  value={formData.inter_percentage}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
                    if (regex.test(value) || value === "") {
                      setFormData((prev) => ({
                        ...prev,
                        inter_percentage: value,
                      }));
                    }
                  }}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                />
              </div>

              {/* --- CALL STATUS AND DEPENDENT FIELDS --- */}
              <div className="flex flex-col col-span-1 sm:col-span-2">
                <label htmlFor="call_status">
                  Call Status<span className="ml-1 text-red-600">*</span>
                </label>
                <select
                  id="call_status"
                  name="call_status"
                  value={formData.call_status}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  required
                >
                  <option value="">Select Status</option>
                  <option value="Contacted">Contacted</option>
                  <option value="Not Answered">Not Answered</option>
                </select>
              </div>
{/* 
              <div className="flex flex-col col-span-1 sm:col-span-2">
                <label
                  htmlFor="is_joined"
                  className="mb-1 font-medium flex items-center"
                >
                  Join Status
                </label>
                <select
                  id="is_joined"
                  name="is_joined"
                  value={formData.is_joined}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={
                    formData.call_status !== "Contacted" ||
                    !(isUpdate || isUpload)
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Already Joined">Already Joined</option>
                  <option value="Not Joined">Not Joined</option>
                </select>
              </div>

              {formData.is_joined === "Already Joined" && (
                <div className="flex flex-col">
                  <label
                    htmlFor="joined_clg"
                    className="mb-1 font-medium flex items-center"
                  >
                    Joined College Name
                    <span className="ml-1 text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="joined_clg"
                    name="joined_clg"
                    value={formData.joined_clg}
                    onChange={handleChange}
                    className={`p-2 bg-slate-100 border rounded ${
                      !(isUpdate || isUpload) && "cursor-not-allowed"
                    }`}
                    disabled={!(isUpdate || isUpload)}
                    required
                  />
                </div>
              )} */}

              <div className="flex flex-col">
                <label htmlFor="program_type">Program Type</label>
                <select
                  id="program_type"
                  name="program_type"
                  value={formData.program_type}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={
                    formData.call_status !== "Contacted" ||
                    !(isUpdate || isUpload)
                  }
                >
                  <option value="">Select Program</option>
                  {Object.keys(coursesData).map((program) => (
                    <option key={program} value={program}>
                      {program}
                    </option>
                  ))}
                </select>
              </div>

              {departments.length > 0 && (
                <div className="flex flex-col">
                  <label htmlFor="department">Department</label>
                  <select
                    id="department"
                    name="department"
                    value={formData.department}
                    onChange={handleChange}
                    className={`p-2 bg-slate-100 border rounded ${
                      !(isUpdate || isUpload) && "cursor-not-allowed"
                    }`}
                    disabled={
                      !(isUpdate || isUpload) || !formData.program_type
                    }
                  >
                    <option value="">Select Department</option>
                    {departments.map((dept) => (
                      <option key={dept} value={dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="flex flex-col">
                <label htmlFor="ug_pg_course">Interested Course(s)</label>
                <select
                  id="ug_pg_course"
                  name="ug_pg_course"
                  value={dropdownValue}
                  onChange={handleSelectChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={
                    courses.length === 0 ||
                    formData.call_status !== "Contacted" ||
                    !(isUpdate || isUpload)
                  }
                >
                  <option value="">Select Course(s)</option>
                  {courses.map((course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
                <div className="flex flex-wrap gap-2 mt-2">
                  {selectedCourses.map((course) => (
                    <div
                      key={course}
                      className="flex items-center bg-blue-100 rounded-full px-3 py-1"
                    >
                      <span>{course}</span>
                      <button
                        type="button"
                        className="ml-2 text-blue-800"
                        disabled={!(isUpdate || isUpload)}
                        onClick={() => handleRemoveTag(course)}
                      >
                        <IoIosCloseCircle className="w-5 h-5" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col col-span-1 sm:col-span-2">
                <label htmlFor="remarks" className="flex items-center">
                  Remarks:
                </label>
                <textarea
                  id="remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  className={`p-2 bg-slate-100 border rounded ${
                    !(isUpdate || isUpload) && "cursor-not-allowed"
                  }`}
                  disabled={!(isUpdate || isUpload)}
                  rows={2}
                />
              </div>

              <div className="flex flex-col col-span-1 sm:col-span-2">
                <div className="flex flex-wrap">
                  <label className="flex items-center mr-4">
                    <input
                      type="radio"
                      name="is_interested"
                      value="Not Interested"
                      checked={formData.is_interested === "Not Interested"}
                      onChange={handleChange}
                      className="mr-2"
                      disabled={
                        formData.call_status !== "Contacted" ||
                        !(isUpdate || isUpload)
                      }
                    />
                    Not Interested
                  </label>
                  <label className="flex items-center mr-4">
                    <input
                      type="radio"
                      name="is_interested"
                      value="Interested"
                      checked={formData.is_interested === "Interested"}
                      onChange={handleChange}
                      className="mr-2"
                      disabled={
                        formData.call_status !== "Contacted" ||
                        !(isUpdate || isUpload)
                      }
                    />
                    Interested
                  </label>
                  <label className="flex items-center mr-4">
                    <input
                      type="radio"
                      name="is_interested"
                      value="Most Interested"
                      checked={formData.is_interested === "Most Interested"}
                      onChange={handleChange}
                      className="mr-2"
                      disabled={
                        formData.call_status !== "Contacted" ||
                        !(isUpdate || isUpload)
                      }
                    />
                    Most Interested
                  </label>
                  <label className="flex items-center mr-4">
                    <input
                      type="radio"
                      name="is_interested"
                      value="Call Back"
                      checked={formData.is_interested === "Call Back"}
                      onChange={handleChange}
                      className="mr-2"
                      disabled={
                        formData.call_status !== "Contacted" ||
                        !(isUpdate || isUpload)
                      }
                    />
                    Call Back
                  </label>
                  <label className="flex items-center mr-4">
                    <input
                      type="radio"
                      name="is_interested"
                      value="Others"
                      checked={formData.is_interested === "Others"}
                      onChange={handleChange}
                      className="mr-2"
                      disabled={
                        formData.call_status !== "Contacted" ||
                        !(isUpdate || isUpload)
                      }
                    />
                    Others
                  </label>
                </div>
                <div className="flex items-center mt-4">
                  {formData.is_interested === "Call Back" && (
                    <div className="mt-2 flex items-center justify-center">
                      <label htmlFor="call_back_reason" className="block mb-2">
                        Call Back Reason
                        <span className="ml-1 text-red-600">*</span>:
                      </label>
                      <select
                        id="call_back_reason"
                        name="call_back_reason"
                        value={formData.call_back_reason || ""}
                        onChange={handleChange}
                        className="p-2 border ml-4 border-gray-300 rounded"
                        required={formData.is_interested === "Call Back"}
                      >
                        <option value="">Select Reason</option>
                        <option value="Call Back">Call Back</option>
                        <option value="Counselling">Counselling</option>
                        <option value="EOD">EOD</option>
                      </select>
                    </div>
                  )}
                  {formData.is_interested === "Others" && (
                    <div className="mt-2 flex items-center justify-center">
                      <label htmlFor="other_reasons" className="block mb-2">
                        Other Reason
                        {formData.call_status === "Contacted" && (
                          <span className="ml-1 text-red-600">*</span>
                        )}
                        :
                      </label>
                      <select
                        id="other_reasons"
                        name="other_reasons"
                        value={formData.other_reasons || ""}
                        onChange={handleChange}
                        className="p-2 border ml-4 border-gray-300 rounded"
                        required={
                          formData.is_interested === "Others" &&
                          formData.call_status === "Contacted"
                        }
                        disabled={
                          !(isUpdate || isUpload) ||
                          formData.call_status === "Not Answered"
                        }
                      >
                        <option value="">Select Reason</option>
                        <option value="Wrong Number">Wrong Number</option>
                        <option value="Not Reachable">Not Reachable</option>
                        <option value="Number Not Working">
                          Number Not Working
                        </option>
                        <option value="Call Declined">Call Declined</option>
                        <option value="Busy">Busy</option>
                        <option value="Switched Off">Switched Off</option>
                        <option value="Incoming Calls Stopped">
                          Incoming Calls Stopped
                        </option>
                      </select>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col">
                <label
                  htmlFor="call_duration"
                  className="flex items-center text-lg font-semibold text-gray-700 mb-2"
                >
                  Call Duration
                </label>
                <div className="flex flex-row space-x-2">
                  <div className="relative">
                    <input
                      type="text"
                      id="hours"
                      name="hours"
                      value={formData.hours.padStart(2, "0")}
                      className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                      disabled
                    />
                    <span className="absolute right-2 top-2 text-gray-500 font-bold">
                      h
                    </span>
                  </div>
                  <div className="flex items-center text-gray-500 font-bold">
                    :
                  </div>
                  <div className="relative">
                    <input
                      type="text"
                      id="minutes"
                      name="minutes"
                      value={formData.minutes.padStart(2, "0")}
                      className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                      disabled
                    />
                    <span className="absolute right-2 top-2 text-gray-500 font-bold">
                      m
                    </span>
                  </div>
                  <div className="flex items-center text-gray-500 font-bold">
                    :
                  </div>
                  <div className="relative">
                    <input
                      type="text"
                      id="seconds"
                      name="seconds"
                      value={formData.seconds.padStart(2, "0")}
                      className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                      disabled
                    />
                    <span className="absolute right-2 top-2 text-gray-500 font-bold">
                      s
                    </span>
                  </div>
                </div>
              </div>

              {(isUpdate || isUpload) && (
                <div className="flex flex-col col-span-1 sm:col-span-2">
                  <button
                    type="submit"
                    className={`bg-blue-600 text-white px-4 py-2 rounded ${
                      loadingSubmit && "cursor-not-allowed"
                    }`}
                    disabled={loadingSubmit}
                  >
                    {loadingSubmit
                      ? "Submitting..."
                      : isUpdate
                      ? "Update Student"
                      : "Add Student"}
                  </button>
                </div>
              )}
            </form>
          </Modal>

          <Modal
            isOpen={searchModalIsOpen}
            onRequestClose={() => {
              setSearchModalIsOpen(false);
              setSearchDistrict("");
              setSearchCity("");
              setSearchCollege("");
            }}
            contentLabel="Search Filters"
            className="mx-auto my-10 mt-[100px] max-w-md bg-white rounded-lg shadow-lg"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          >
            <div className="sticky top-0 z-10 bg-white px-6 py-4 border-b">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">Search Filters</h2>
                <button onClick={() => setSearchModalIsOpen(false)}>
                  <AiOutlineClose className="w-6 h-6 text-gray-600 hover:text-gray-800" />
                </button>
              </div>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex flex-col">
                <label htmlFor="district-filter" className="mb-1 font-medium">
                  District
                </label>
                <select
                  id="district-filter"
                  className="p-2 border rounded"
                  value={searchDistrict}
                  onChange={(e) => {
                    setSearchDistrict(e.target.value);
                    setSearchCity("");
                    setSearchCollege("");
                  }}
                >
                  <option value="">Select District</option>
                  {Array.from(
                    new Set(filteredStudents.map((student) => student.district))
                  )
                    .filter(Boolean)
                    .map((district) => (
                      <option key={district} value={district}>
                        {district}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="city-filter" className="mb-1 font-medium">
                  City
                </label>
                <select
                  id="city-filter"
                  className="p-2 border rounded"
                  value={searchCity}
                  onChange={(e) => {
                    setSearchCity(e.target.value);
                    setSearchCollege("");
                  }}
                  disabled={!searchDistrict}
                >
                  <option value="">
                    {searchDistrict ? "Select City" : "First select District"}
                  </option>
                  {Array.from(
                    new Set(
                      filteredStudents
                        .filter(
                          (student) =>
                            searchDistrict &&
                            student.district?.toLowerCase() ===
                              searchDistrict.toLowerCase()
                        )
                        .map((student) => student.city)
                    )
                  )
                    .filter(Boolean)
                    .map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="college-filter" className="mb-1 font-medium">
                  College Name
                </label>
                <select
                  id="college-filter"
                  className="p-2 border rounded"
                  value={searchCollege}
                  onChange={(e) => setSearchCollege(e.target.value)}
                  disabled={!searchCity}
                >
                  <option value="">
                    {searchCity ? "Select College" : "First select City"}
                  </option>
                  {Array.from(
                    new Set(
                      filteredStudents
                        .filter(
                          (student) =>
                            searchCity &&
                            student.city?.toLowerCase() ===
                              searchCity.toLowerCase()
                        )
                        .map((student) => student.clg_name)
                    )
                  )
                    .filter(Boolean)
                    .map((college) => (
                      <option key={college} value={college}>
                        {college}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex justify-end pt-4">
                <button
                  onClick={() => {
                    setSearchDistrict("");
                    setSearchCity("");
                    setSearchCollege("");
                    setFilteredStudents(studentsData);
                  }}
                  className="px-4 py-2 mr-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Clear
                </button>
                <button
                  onClick={() => {
                    const filtered = studentsData.filter((student) => {
                      const districtMatch =
                        !searchDistrict ||
                        student.district
                          ?.toLowerCase()
                          .includes(searchDistrict.toLowerCase());
                      const cityMatch =
                        !searchCity ||
                        student.city
                          ?.toLowerCase()
                          .includes(searchCity.toLowerCase());
                      const collegeMatch =
                        !searchCollege ||
                        student.clg_name
                          ?.toLowerCase()
                          .includes(searchCollege.toLowerCase());

                      return districtMatch && cityMatch && collegeMatch;
                    });
                    setFilteredStudents(filtered);
                    setSearchModalIsOpen(false);
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Apply
                </button>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default EnrolledStudents;